// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Row$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as PricingDashboardAssetsManager from "../../../../../assets/PricingDashboardAssetsManager.bs.js";

var error_info_icon = PricingDashboardAssetsManager.getImage("error-info-icon.svg");

function getErrorString(err) {
  return err._0.message;
}

function ErrorBanner(Props) {
  var error = Props.error;
  return React.createElement(Row$Catalyst.make, {
              children: null,
              className: "c-error-banner"
            }, React.createElement("img", {
                  className: "error-icon",
                  src: error_info_icon
                }), React.createElement("div", {
                  className: "error-msg"
                }, error._0.message));
}

var make = ErrorBanner;

export {
  error_info_icon ,
  getErrorString ,
  make ,
  
}
/* error_info_icon Not a pure module */
